import { useState } from "react";
import { X, ArrowRight, MagnifyingGlass } from "@phosphor-icons/react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function RequestMatchModal({ pkg, region, onClose }) {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [note, setNote] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!name.trim() || !phone.trim()) {
      toast.error("Name and phone are required");
      return;
    }
    setLoading(true);
    try {
      await api.post("/requests/match", {
        vertical: pkg.vertical || pkg.lookup_key.split("_")[0],
        lookup_key: pkg.lookup_key,
        service_name: pkg.name,
        contact_name: name.trim(),
        contact_phone: phone.trim(),
        region,
        note: note.trim() || null,
      });
      toast.success("Request received · Ralph will call you within 60 min");
      onClose();
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not send request");
      setLoading(false);
    }
  };

  return (
    <div
      data-testid="request-match-modal"
      className="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-8 bg-black/80 backdrop-blur-sm"
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="relative w-full max-w-lg rounded-3xl border border-[#D4AF37]/40 bg-[#0F0F11] shadow-[0_30px_100px_-30px_rgba(212,175,55,0.4)] p-8"
      >
        <button
          onClick={onClose}
          data-testid="request-match-close"
          aria-label="Close"
          className="absolute top-5 right-5 w-9 h-9 rounded-full flex items-center justify-center text-zinc-400 hover:text-white hover:bg-white/10 transition"
        >
          <X size={18} weight="bold" />
        </button>

        <div className="flex items-center gap-2 mb-3">
          <MagnifyingGlass weight="duotone" size={16} className="text-[#D4AF37]" />
          <div className="eyebrow gold-text">Request a match</div>
        </div>
        <h3 className="font-serif-display text-2xl text-white mb-2">{pkg.name}</h3>
        <p className="text-sm text-zinc-400 mb-6">
          We'll hand-match a vetted professional and call you back within 60 minutes to confirm details, pricing, and schedule.
        </p>

        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="eyebrow block mb-2">Your name</label>
            <input
              value={name}
              onChange={(e) => setName(e.target.value)}
              data-testid="req-match-name"
              className="w-full bg-black/40 border border-white/10 rounded-lg px-4 py-3 text-white outline-none focus:border-[#D4AF37]"
              placeholder="Full name"
            />
          </div>
          <div>
            <label className="eyebrow block mb-2">Phone / WhatsApp</label>
            <input
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              data-testid="req-match-phone"
              type="tel"
              className="w-full bg-black/40 border border-white/10 rounded-lg px-4 py-3 text-white outline-none focus:border-[#D4AF37]"
              placeholder="+231 77 000 0000"
            />
          </div>
          <div>
            <label className="eyebrow block mb-2">Anything specific? <span className="text-zinc-600 lowercase">(optional)</span></label>
            <textarea
              value={note}
              onChange={(e) => setNote(e.target.value)}
              data-testid="req-match-note"
              rows={3}
              className="w-full bg-black/40 border border-white/10 rounded-lg px-4 py-3 text-white outline-none focus:border-[#D4AF37]"
              placeholder="e.g. wedding on Feb 14, or specialty needed"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="req-match-submit"
            className="w-full py-3 rounded-full bg-[#D4AF37] text-black font-semibold text-sm hover:bg-[#F3E5AB] transition disabled:opacity-60 inline-flex items-center justify-center gap-2"
          >
            {loading ? "Sending…" : "Send request"} <ArrowRight size={14} weight="bold" />
          </button>
        </form>
      </div>
    </div>
  );
}
